exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".address-privacy-label{font-size:16px;padding-left:10px}.address-privacy-label-container{text-align:center;padding-left:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/forms/AddressFormPanel/styles.scss
// module id = 765
// module chunks = 0